import { render } from "./SaveNotification.vue?vue&type=template&id=4353aecd"
import script from "./SaveNotification.vue?vue&type=script&lang=js"
export * from "./SaveNotification.vue?vue&type=script&lang=js"
script.render = render

export default script